module.exports = __webpack_public_path__ + "static/media/emptyPicture.d684be77.svg";